module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"r-library":"Библиотека компонентов","traffic-counts":"Замеры интенсивности","situation-center":"Ситуационный центр"},"en":{"r-library":"RITM - library","traffic-counts":"Traffic Counts","situation-center":"Situation Center"}}')
  delete Component.options._Ctor
}
